/**
 * @file
 * @author dailin01
 */
import React, { useContext } from 'react';
import classNames from 'classnames';
import MenuContext from './MenuContext';
import { cloneElement } from '../_util/reactNode';
const HeaderMenu = props => {
    const { headerMenu, viceHeaderMenu, logoInfo, titleInfo, otherArea, headerStyle } = props;
    /**
     * logo string - imgString + url  ReactNode - selfCus
     * title
     * subTitleUrl
     * headerMenu
     * viceHeaderMenu
     * otherArea
     */
    const { prefixCls } = useContext(MenuContext);
    const { logo, urlConfig: logoUrlConfig } = logoInfo;
    return (<div className={`${prefixCls}-header-container`}>
            <div className={`${prefixCls}-header`} style={headerStyle}>
                <div className={`${prefixCls}-header-head`}>
                    <a className={`${prefixCls}-header-logo`} {...logoUrlConfig}>
                        {logo && (typeof logo === 'string')
            ? <img src={logo}/>
            : logo}
                    </a>
                    {!!titleInfo && (typeof titleInfo.title === 'string' ? (<div className={`${prefixCls}-header-title`}>
                                <a {...titleInfo.urlConfig}>
                                    {titleInfo.title}
                                </a>
                            </div>) : titleInfo.title)}
                </div>
                <div className={`${prefixCls}-header-nav`}>
                    {cloneElement(headerMenu, {
            mode: 'horizontal',
            className: classNames(`${prefixCls}-header-nav-menu`, 'acud-menu-with-icon')
        })}
                    {cloneElement(viceHeaderMenu, {
            mode: 'horizontal',
            className: classNames(`${prefixCls}-header-nav-menu`, `${prefixCls}-header-nav-menu-vice`, 'acud-menu-with-icon')
        })}
                </div>
                {!!otherArea && cloneElement(otherArea, {
            className: `${prefixCls}-header-area`
        })}
            </div>
        </div>);
};
export default HeaderMenu;
